import { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";

const axios = require("axios").default;

function millisToMinutesAndSeconds(millis) {
  var minutes = Math.floor(millis / 60000);
  var seconds = ((millis % 60000) / 1000).toFixed(0);
  return minutes + ":" + (seconds < 10 ? "0" : "") + seconds;
}

function Test() {
  let params = useParams();

  const navigate = useNavigate();
  const { state } = useLocation();
  const [flashcards, setFlashcards] = useState([{}]);
  const [flashcardIndices, setFlashcardIndices] = useState(0);
  const [count, setCount] = useState(0);
  const [userInput, setUserInput] = useState("");
  const [userAnswers, setUserAnswers] = useState([]);
  const [miliSeconds, setMiliSeconds] = useState(state.seconds * 1000);
  const [submitted, setSubmitted] = useState(false);

  // checks for correct answer on submit
  function checkAnswer(e) {
    e.preventDefault();

    setMiliSeconds(state.seconds * 1000);

    if (userInput === flashcards[count].description) {
      setUserAnswers([
        ...userAnswers,
        { correct: true, id: flashcards[count].id },
      ]);
    } else {
      setUserAnswers([
        ...userAnswers,
        { correct: false, id: flashcards[count].id },
      ]);
    }

    if (flashcardIndices !== count) {
      setCount(count + 1);
    }

    setUserInput("");
  }

  useEffect(() => {
    const token = localStorage.getItem("token");

    axios
      .post(
        `https://application-flashcards.herokuapp.com/api/sets/${params.setname}`,
        { token }
      )
      .then(function (response) {
        setFlashcards(response.data[0].flashcards);
        setFlashcardIndices(response.data[0].flashcards.length - 1);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);

  // if time is set, checks answer after time passes
  useEffect(() => {
    if (userAnswers.length === flashcards.length) {
      navigate(`/dashboard/set/test/${params.setname}/results`, {
        state: {
          userAnswers,
          nameCap: state.nameCap,
        },
      });
    }
  }, [userAnswers]);

  // makes time work in hours and seconds
  useEffect(() => {
    if (state.seconds > 0) {
      setTimeout(() => {
        setMiliSeconds(miliSeconds - 1000);
        if (miliSeconds === 1000) {
          setMiliSeconds(state.seconds * 1000);
          console.log("done");

          //   if (userInput === flashcards[count].description) {
          //     setUserAnswers([
          //       ...userAnswers,
          //       { correct: true, id: flashcards[count].id },
          //     ]);
          //   } else {
          //     setUserAnswers([
          //       ...userAnswers,
          //       { correct: false, id: flashcards[count].id },
          //     ]);
          //   }

          //   if (flashcardIndices !== count) {
          //     setCount(count + 1);
          //   }

          //   setUserInput("");
        }
      }, 1000);
    }
  }, [miliSeconds]);

  return (
    <>
      <div className="bg-zinc-800 text-slate-200 py-2 px-32 flex justify-between md:px-12">
        <div>
          <p className="text-xl font-semibold my-2">{state.nameCap}</p>
        </div>
      </div>
      <div className="rounded-lg border-solid border border-slate-300 my-2 w-4/12 shadow-md p-5 mx-auto mt-20 h-52 flex justify-center md:w-10/12">
        <p className="flex flex-col justify-center text-xl break-words w-full text-center">
          {flashcards[count].title}
        </p>
      </div>
      <form className="rounded-lg border-solid border border-slate-300 my-2 w-4/12 shadow-xl p-5 mx-auto flex justify-between items-center md:w-10/12 lg:flex-col">
        <input
          className="w-9/12 border border-slate-400 lg:w-full lg:mb-2"
          type="text"
          value={userInput}
          onChange={(e) => {
            setUserInput(e.target.value);
          }}
        />
        <button
          className="w-3/12 ml-2 text-white border-solid border border-neutral-50 rounded p-1 my-1 bg-green-400 hover:bg-green-500 lg:w-full lg:ml-0"
          onClick={checkAnswer}
        >
          Submit
        </button>
      </form>
      {state.seconds > 0 ? (
        <p>Time: {millisToMinutesAndSeconds(miliSeconds)}</p>
      ) : null}
    </>
  );
}

export default Test;
